import React from 'react';
import '../styles/ProgressBar.css';

function ProgressBar({ current, total }) {
    const percentage = Math.round((current / total) * 100);

    return (
        <div className="progress-bar-wrapper">
            <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: `${percentage}%` }}>
                    <span className="progress-bar-text">{current} av {total}</span>
                </div>
            </div>
        </div>
    );
}

export default ProgressBar;
